import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import PublicLayout from "@/components/PublicLayout";
import DashboardLayout from "@/components/DashboardLayout";

import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import CourseDetail from "@/pages/CourseDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import PaymentReturn from "@/pages/PaymentReturn";
import VerifyCertificate from "@/pages/VerifyCertificate";
import CourseBuilder from "@/pages/instructor/CourseBuilder";

import Login from "@/pages/auth/Login";
import Register from "@/pages/auth/Register";
import ForgotPassword from "@/pages/auth/ForgotPassword";
import ResetPassword from "@/pages/auth/ResetPassword";
import AuthCallback from "@/pages/auth/AuthCallback";

import DashboardHome from "@/pages/dashboard/DashboardHome";
import MyCourses from "@/pages/student/MyCourses";
import CoursePlayer from "@/pages/student/CoursePlayer";
import MyCertificates from "@/pages/student/MyCertificates";
import MyOrders from "@/pages/student/MyOrders";

function AppShell() {
  const location = useLocation();
  // Emergent OAuth returns to /dashboard#session_id=... — catch it before routing
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/catalogo" element={<Catalog />} />
        <Route path="/curso/:id" element={<CourseDetail />} />
        <Route path="/verificar" element={<VerifyCertificate />} />
      </Route>

      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      <Route path="/carrito" element={<ProtectedRoute roles={["student"]}><Cart /></ProtectedRoute>} />
      <Route path="/checkout" element={<ProtectedRoute roles={["student"]}><Checkout /></ProtectedRoute>} />
      <Route path="/pago/retorno" element={<ProtectedRoute roles={["student"]}><PaymentReturn /></ProtectedRoute>} />

      <Route path="/dashboard/curso/:id" element={<ProtectedRoute roles={["student"]}><CoursePlayer /></ProtectedRoute>} />
      <Route path="/dashboard/curso-editor/:id" element={<ProtectedRoute roles={["instructor", "admin"]}><CourseBuilder /></ProtectedRoute>} />

      <Route path="/dashboard" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
        <Route index element={<DashboardHome />} />
        <Route path="cursos" element={<ProtectedRoute roles={["student"]}><MyCourses /></ProtectedRoute>} />
        <Route path="certificados" element={<ProtectedRoute roles={["student"]}><MyCertificates /></ProtectedRoute>} />
        <Route path="compras" element={<ProtectedRoute roles={["student"]}><MyOrders /></ProtectedRoute>} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <AppShell />
            <Toaster position="top-right" richColors />
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
